import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getShipments,
    getShipmentsTotal,
    updateShipmentDelivered,
    updateShipmentTracing,
    updateShipmentTrackingStatus,
    cancelShipment,
    getShipmentsReport,
    getShipmentsServiceReport,
    getShipmentsTracingReport,
    getShipmentsCanceledReport,
    uploadShipmentsTracingReport
}

function getShipments(query) {
    return new Promise((resolve, reject) => {

        query.timezone = new Date().getTimezoneOffset()/60

        Superagent
           .get(`${HOST_API}/shipments`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getShipmentsTotal() {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/shipments/total`)
           .set('access', Storage.getItem('access'))
           .query({admin: true})
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateShipmentDelivered(guide) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/shipments/${guide}/delivered`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateShipmentTracing(shipmentId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/shipments/${shipmentId}/tracing`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateShipmentTrackingStatus(shipmentId, data){
    return new Promise((resolve, reject) => {
        Superagent
        .put(`${HOST_API}/shipments/${shipmentId}/status`)
        .set('access', Storage.getItem('access'))
        .send(data)
        .end((err, res) => {
            resolve(res.body)
        })
    })
}

function cancelShipment(shipmentId, refund) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/shipments/${shipmentId}/cancel`)
           .set('access', Storage.getItem('access'))
           .query({refund})
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getShipmentsReport(query) {
    return new Promise((resolve, reject) => {

        const data = { ...query }

        data.dateStart = query.dateStart.toISOString()
        data.dateEnd = query.dateEnd.toISOString()
        data.timezone = new Date().getTimezoneOffset()/60

        Superagent
            .get(`${HOST_API}/shipments/report`)
            .set('access', Storage.getItem('access'))
            .query(data)
            .responseType('blob')
            .end((err, res) => {
                resolve(res.body)
            })
    })
}

function getShipmentsServiceReport(query) {
    return new Promise((resolve, reject) => {

        let sendQuery = {
            provider: query.provider,
            service: query.service,
            dateStart: query.dateStart.toISOString(),
            dateEnd: query.dateEnd.toISOString(),
        }

        Superagent
            .get(`${HOST_API}/shipments/service/report`)
            .set('access', Storage.getItem('access'))
            .query(sendQuery)
            .responseType('blob')
            .end((err, res) => {
                if(err)
                    resolve(null)
                else
                    resolve(res.body)
            })
    })
}

function getShipmentsTracingReport() {
    return new Promise((resolve, reject) => {

        Superagent
            .get(`${HOST_API}/shipments/tracing/report`)
            .set('access', Storage.getItem('access'))
            .responseType('blob')
            .end((err, res) => {
                if(err)
                    resolve(null)
                else
                    resolve(res.body)
            })
    })
}

function getShipmentsCanceledReport(query) {
    return new Promise((resolve, reject) => {

        let sendQuery = {
            dateStart: query.dateStart.toISOString(),
            dateEnd: query.dateEnd.toISOString(),
        }

        Superagent
            .get(`${HOST_API}/shipments/canceled/report`)
            .set('access', Storage.getItem('access'))
            .query(sendQuery)
            .responseType('blob')
            .end((err, res) => {
                if(err)
                    resolve(null)
                else
                    resolve(res.body)
            })
    })
}

function uploadShipmentsTracingReport(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/shipments/tracing/report`)
           .set('access', Storage.getItem('access'))
           .attach('shipmentsFile', data.shipmentsFile)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}